import Cookies from 'js-cookie'

export default class SalePopup {
  constructor(component) {
    this.dom = {
      $component: component,
      $closePopUp: document.querySelectorAll('.js-salePopUpClose'),
      $underlay: document.querySelector('.js-salePopUpUnderlay')
    }
    this.state = {
      open: false,
      openPopUpClass: 'openPopUp',
      activeUnderlayClass: 'isActive',
      cookie: {
        initial: Cookies.get('salePopupShown'),
        name: 'salePopupShown',
        value: true
      }
    }
    this.closePopUpHandler = this.closePopUp.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom, state } = this
    dom.$closePopUp.forEach($toggle => $toggle.addEventListener('click', this.closePopUpHandler))

    if (!state.cookie.initial) {
      const delay = parseInt(dom.$component.dataset.delay, 10) * 1000

      state.expires = parseInt(dom.$component.dataset.expires, 10)

      setTimeout(() => {
        this.openPopUp()
        this.setCookie()
      }, delay)
    }
  }

  openPopUp() {
    const { dom, state } = this
    dom.$component.setAttribute('aria-hidden', 'false')
    dom.$component.setAttribute('aria-expanded', 'true')
    dom.$component.classList.add(state.openPopUpClass)
    dom.$underlay.classList.add(state.activeUnderlayClass)
    state.open = true
  }

  closePopUp() {
    const { dom, state } = this
    dom.$component.setAttribute('aria-hidden', 'true')
    dom.$component.setAttribute('aria-expanded', 'false')
    dom.$component.classList.remove(state.openPopUpClass)
    dom.$underlay.classList.remove(state.activeUnderlayClass)
    state.open = false
  }

  setCookie() {
    const { state } = this

    Cookies.set(state.cookie.name, state.cookie.value, { expires: state.expires })
  }

  resetCookie() {
    const { state } = this

    Cookies.remove(state.cookie.name)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.SalePopup = this
  }
}
